import { Action } from "@ngrx/store";
import { FilterSortPaginateOption } from "../../../../shared/models";

export const GET_PREDICTION_SCHEDULE = '[Prediction Schedule] Get Prediction Schedule';
export const GET_PREDICTION_SCHEDULE_SUCCESS = '[Prediction Schedule] Get Prediction Schedule Success';
export const GET_PREDICTION_SCHEDULE_FAIL = '[Prediction Schedule] Get Prediction Schedule Fail';
export const CLEAR_PREDICTION_SCHEDULE = '[Prediction Schedule] Clear Prediction Schedule';

export class GetPredictionSchedule implements Action {
  readonly type = GET_PREDICTION_SCHEDULE;
  constructor(public payload: FilterSortPaginateOption) { }
}

export class GetPredictionScheduleSuccess implements Action {
  readonly type = GET_PREDICTION_SCHEDULE_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetPredictionScheduleFail implements Action {
  readonly type = GET_PREDICTION_SCHEDULE_FAIL;
  constructor(public payload: any = null) { }
}

export class ClearPredictionSchedule implements Action {
  readonly type = CLEAR_PREDICTION_SCHEDULE;
  constructor() { }
}

export type PredictionScheduleActions =
  | GetPredictionSchedule
  | GetPredictionScheduleSuccess
  | GetPredictionScheduleFail
  | ClearPredictionSchedule;